<template>
  <div>
    <div class="col-sm-12 col-xs-12 col-md-12 notification_tabs">
      <template>
        <!-- <el-tabs class="elTabs" v-model="activeAlertPrefTab">
          <el-tab-pane name="RegTracker">
            <span slot="label">Registration Tracker</span>
          </el-tab-pane>
          <el-tab-pane name="RegWatch">
            <span slot="label">Regulatory Watch</span>
          </el-tab-pane>
          <el-tab-pane name="SmartBuilder">
            <span slot="label">Smart Builder</span>
          </el-tab-pane>
           <el-tab-pane name="SmartExchange" v-if="display_smart_exchange">
            <span slot="label">Smart Exchange</span>
          </el-tab-pane>
          <el-tab-pane name="GeneralNotifications">
            <span slot="label">General Notifications</span>
          </el-tab-pane>
        </el-tabs> -->
        <div class="tabs-left">
          <ul class="nav nav-tabs" role="tablist">
            <li
              role="presentation"
              class="nav-item"
              :class="{ active: activeAlertPrefTab == 'RegTracker' }"
            >
              <span
                class="nav-link"
                role="tab"
                @click="activeAlertPrefTab = 'RegTracker'"
                data-toggle="tab"
                >Registration Tracker</span
              >
            </li>
            <li
              role="presentation"
              class="nav-item"
              :class="{ active: activeAlertPrefTab == 'RegWatch' }"
            >
              <span
                class="nav-link"
                role="tab"
                @click="activeAlertPrefTab = 'RegWatch'"
                data-toggle="tab"
                >Regulatory Watch</span
              >
            </li>
            <li
              role="presentation"
              class="nav-item"
              :class="{ active: activeAlertPrefTab == 'SmartBuilder' }"
            >
              <span
                class="nav-link"
                role="tab"
                @click="activeAlertPrefTab = 'SmartBuilder'"
                data-toggle="tab"
                >Smart Builder</span
              >
            </li>
            <li
              role="presentation"
              class="nav-item"
              v-if="display_smart_exchange"
              :class="{ active: activeAlertPrefTab == 'SmartExchange' }"
            >
              <span
                class="nav-link"
                role="tab"
                @click="activeAlertPrefTab = 'SmartExchange'"
                data-toggle="tab"
                >Smart Exchange</span
              >
            </li>
            <li
              role="presentation"
              class="nav-item"
              :class="{ active: activeAlertPrefTab == 'GeneralNotifications' }"
            >
              <span
                class="nav-link"
                role="tab"
                @click="activeAlertPrefTab = 'GeneralNotifications'"
                data-toggle="tab"
                >General Notifications</span
              >
            </li>
          </ul>
        </div>
      </template>
      <div v-show="activeAlertPrefTab == 'RegTracker' && displayRegTracker">
        <div class="mb-15 mt-15 alert-content">
          Indicate the type of notification you would like to receive. Notifications can be sent via
          email and/or displayed within the application. In-app notifications can be viewed on the
          Notifications page.
        </div>
        <div class="container1">
          <div class="section">
            <div class="scrollable-content content">
              <div class="row_wrapper row">
                <div class="col-md-6 col-sm-6 col-xs-12 header_label_text">Type</div>
                <div class="col-md-3 col-sm-3 hide_xs in_app_label header_label_text">
                  In-app Notification
                </div>
                <div class="col-md-3 col-sm-3 email_tab hide_xs">
                  <span class="ml-15 header_label_text">Email</span>
                  <el-popover
                    placement="bottom-end"
                    trigger="click"
                    class="main_popover"
                    @show="infoActive = true"
                    @hide="infoActive = false"
                  >
                    <div>
                      <div class="mb-10">
                        <span class="tooltip_sub_content_heading">Never:</span> No emails will be
                        sent
                      </div>
                      <div class="mb-10">
                        <span class="tooltip_sub_content_heading">Every Alert:</span> Emails will be
                        sent immediately and for every triggered notification
                      </div>
                      <div class="mb-10">
                        <span class="tooltip_sub_content_heading">Daily summary:</span> A daily
                        summary of the triggered notification type will be sent
                      </div>
                      <div class="mb-10">
                        <span class="tooltip_sub_content_heading">Weekly summary:</span> A weekly
                        summary of the triggered notification type will be sent
                      </div>
                    </div>
                    <!-- <template #reference> -->
                    <img
                      class="info-img"
                      src="/static/images/icons/info_icon.svg"
                      v-if="!infoActive"
                      alt="infoa-icon"
                      slot="reference"
                    />
                    <img
                      class="info-img"
                      src="/static/images/icons/info_icon_active.svg"
                      v-if="infoActive"
                      alt="infoactive-icon"
                      slot="reference"
                    />
                    <!-- </template> -->
                  </el-popover>
                </div>
              </div>
              <div class="row_wrapper row">
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <label class="alert_text">Registrations are added</label>
                </div>
                <div class="col-md-3 col-sm-3 col-xs-6 toggle_switch">
                  <small class="display_xs">In-app Notifications</small>
                  <label class="switch">
                    <input type="checkbox" v-model="selectedPreferences['alertRegistrationNew']" />
                    <span class="slider round"></span>
                  </label>
                  <span v-if="selectedPreferences['alertRegistrationNew']" class="switch_label"
                    >On</span
                  >
                  <span v-else class="switch_label switch_off">Off</span>
                </div>
                <div class="col-md-3 col-sm-3 col-xs-6 xs-mr-tp-5">
                  <small class="display_xs ml-20">Email</small>
                  <multiselect
                    v-if="loaderStatus == false"
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    class="multiselect-single-dropdown"
                    :searchable="false"
                    open-direction="bottom"
                    :options="frequency_options.map((frequency) => frequency.value)"
                    :custom-label="
                      (option) => frequency_options.find((x) => x.value === option).label
                    "
                    v-model="email_frequency['email_registration_new']"
                    placeholder="Select"
                  >
                    <span slot="noResult">No matching data</span>
                  </multiselect>
                </div>
              </div>
              <div class="row_wrapper row">
                <div class="col-md-6 col-xs-12 col-sm-6">
                  <label class="alert_text">Registrations are edited</label>
                </div>
                <div class="col-md-3 col-sm-3 col-xs-6 toggle_switch">
                  <small class="display_xs">In-app Notifications</small>
                  <label class="switch">
                    <input
                      type="checkbox"
                      v-model="selectedPreferences['alertRegistrationModified']"
                    />
                    <span class="slider round"></span>
                  </label>
                  <span v-if="selectedPreferences['alertRegistrationModified']" class="switch_label"
                    >On</span
                  >
                  <span v-else class="switch_label switch_off">Off</span>
                </div>
                <div class="col-md-3 col-sm-3 col-xs-6 xs-mr-tp-5">
                  <small class="display_xs ml-20">Email</small>
                  <multiselect
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    class="multiselect-single-dropdown"
                    open-direction="bottom"
                    :searchable="false"
                    :options="frequency_options.map((frequency) => frequency.value)"
                    :custom-label="
                      (option) => frequency_options.find((x) => x.value === option).label
                    "
                    v-model="email_frequency['email_registration_modified']"
                    placeholder="Select"
                  >
                    <span slot="noResult">No matching data</span>
                  </multiselect>
                </div>
              </div>
              <div class="row_wrapper row">
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <label class="alert_text">Registrations are deleted</label>
                </div>
                <div class="col-md-3 col-sm-3 col-xs-6 toggle_switch">
                  <small class="display_xs">In-app Notifications</small>
                  <label class="switch">
                    <input
                      type="checkbox"
                      v-model="selectedPreferences['alertRegistrationDeleted']"
                    />
                    <span class="slider round"></span>
                  </label>
                  <span v-if="selectedPreferences['alertRegistrationDeleted']" class="switch_label"
                    >On</span
                  >
                  <span v-else class="switch_label switch_off">Off</span>
                </div>
                <div class="col-md-3 col-sm-3 col-xs-6 xs-mr-tp-5">
                  <small class="display_xs ml-20">Email</small>
                  <multiselect
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    class="multiselect-single-dropdown"
                    open-direction="bottom"
                    :searchable="false"
                    :options="frequency_options.map((frequency) => frequency.value)"
                    :custom-label="
                      (option) => frequency_options.find((x) => x.value === option).label
                    "
                    v-model="email_frequency['email_registration_deleted']"
                    placeholder="Select"
                  >
                    <span slot="noResult">No matching data</span>
                  </multiselect>
                </div>
              </div>
              <div class="row_wrapper row">
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <label class="alert_text">Registrations status changes</label>
                </div>
                <div class="col-md-3 col-sm-3 col-xs-6 toggle_switch">
                  <small class="display_xs">In-app Notifications</small>
                  <label class="switch">
                    <input
                      type="checkbox"
                      v-model="selectedPreferences['alertRegistrationStatusChange']"
                    />
                    <span class="slider round"></span>
                  </label>
                  <span
                    v-if="selectedPreferences['alertRegistrationStatusChange']"
                    class="switch_label"
                    >On</span
                  >
                  <span v-else class="switch_label switch_off">Off</span>
                </div>
                <div class="col-md-3 col-sm-3 col-xs-6 xs-mr-tp-5">
                  <small class="display_xs ml-20">Email</small>
                  <multiselect
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    class="multiselect-single-dropdown"
                    :searchable="false"
                    :options="frequency_options.map((frequency) => frequency.value)"
                    :custom-label="
                      (option) => frequency_options.find((x) => x.value === option).label
                    "
                    v-model="email_frequency['email_registration_status_change']"
                    placeholder="Select"
                  >
                    <span slot="noResult">No matching data</span>
                  </multiselect>
                </div>
              </div>
              <div class="row_wrapper pb-15 row">
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <label class="alert_text">Registration expire soon</label>
                </div>
                <div class="col-md-3 col-sm-3 col-xs-6 toggle_switch">
                  <small class="display_xs">In-app Notifications</small>
                  <label class="switch">
                    <input
                      type="checkbox"
                      v-model="selectedPreferences['alertRegistrationExpireSoon']"
                    />
                    <span class="slider round"></span>
                  </label>
                  <span
                    v-if="selectedPreferences['alertRegistrationExpireSoon']"
                    class="switch_label"
                    >On</span
                  >
                  <span v-else class="switch_label switch_off">Off</span>
                </div>
                <div class="col-md-3 col-sm-3 col-xs-6 xs-mr-tp-5">
                  <small class="display_xs ml-20">Email</small>
                  <multiselect
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    class="multiselect-single-dropdown"
                    :searchable="false"
                    :options="frequency_options.map((frequency) => frequency.value)"
                    :custom-label="
                      (option) => frequency_options.find((x) => x.value === option).label
                    "
                    v-model="email_frequency['email_registration_expire_soon']"
                    placeholder="Select"
                  >
                  </multiselect>
                </div>
              </div>
            </div>
            <div
              class="row indicator-block mr-5"
              v-if="
                account_type_id === 2 &&
                ((selectedPreferences['alertRegistrationExpireSoon'] !== '' &&
                  !selectedPreferences['alertRegistrationExpireSoon']) ||
                  (email_frequency['email_registration_expire_soon'] !== '' &&
                    email_frequency['email_registration_expire_soon'] === 'never'))
              "
            >
              <div class="indicator-message-expires">
                ** As an In-country Representation client you will continue to receive in-app and
                email notifications on upcoming expirations for Emergo-managed records.
                Notifications will be turned off <b>only</b> for records added directly by your
                organization. **
              </div>
            </div>
          </div>
        </div>
      </div>
      <notification-no-service
        @closepopup="$emit('closepopup')"
        v-show="activeAlertPrefTab == 'RegTracker' && no_display_regtracker"
      ></notification-no-service>

      <div v-show="activeAlertPrefTab == 'RegWatch' && displayRegUpdates">
        <notification-regulatory-update
          :permissions="permissions"
          ref="regUpdate"
          :frequency_options="frequency_options"
          :regulatory_email_notification_country_ids="regulatory_email_notification_country_ids"
          :email_frequency="email_frequency['email_regulatory_change']"
          :account_id="account_id"
          :sync_display.sync="sync_display"
          :default_country="default_country"
          @loaderStatus="getLoaderStatus"
        ></notification-regulatory-update>
      </div>
      <notification-no-service
        @closepopup="$emit('closepopup')"
        v-show="activeAlertPrefTab == 'RegWatch' && no_display_regwatch"
      ></notification-no-service>

      <div v-show="activeAlertPrefTab == 'SmartBuilder' && displaySmartBuilder">
        <notification-smart-builder
          :sb_email_preference.sync="sb_email_preference"
          :sb_in_app_preference.sync="sb_in_app_preference"
        ></notification-smart-builder>
      </div>
      <notification-no-service
        @closepopup="$emit('closepopup')"
        v-show="activeAlertPrefTab == 'SmartBuilder' && no_display_smart_builder"
      ></notification-no-service>

      <div v-show="activeAlertPrefTab == 'SmartExchange'">
        <profile-notification-smart-exchange
          :sx_in_app_preference.sync="sx_in_app_preference"
        ></profile-notification-smart-exchange>
      </div>
      <div
        v-show="
          activeAlertPrefTab == 'GeneralNotifications' &&
          (displayProdClsfnNotifications || displayRegPathwayNotifications)
        "
      >
        <profile-notifications-general
          :regpathway_email_preference.sync="regpathway_email_preference"
          :regpathway_in_app_preference.sync="regpathway_in_app_preference"
          :prodclfn_email_preference.sync="prodclfn_email_preference"
          :prodclfn_in_app_preference.sync="prodclfn_in_app_preference"
          :displayProdClsfnNotifications="displayProdClsfnNotifications"
          :displayRegPathwayNotifications="displayRegPathwayNotifications"
        ></profile-notifications-general>
      </div>
      <notification-no-service
        @closepopup="$emit('closepopup')"
        v-show="
          activeAlertPrefTab == 'GeneralNotifications' &&
          !(displayProdClsfnNotifications || displayRegPathwayNotifications)
        "
      ></notification-no-service>
      <loader :loadingStatus="loaderStatus"></loader>
    </div>
    <div
      v-if="
        displayRegUpdates ||
        displayRegTracker ||
        displaySmartBuilder ||
        display_smart_exchange ||
        displayProdClsfnNotifications ||
        displayRegPathwayNotifications
      "
      class="col-sm-12 col-xs-12 footer"
    >
      <div class="col-md-2 col-md-offset-7 col-sm-offset-5 col-sm-3 col-xs-5 xs-pd-lt-0">
        <button
          type="button"
          class="btn btn-block emergo-white-button"
          @click="$emit('closepopup')"
          data-dismiss="modal"
        >
          Cancel
        </button>
      </div>
      <div class="col-md-3 col-sm-4 col-xs-7 xs-pd-lt-0 xs-pd-rt-0">
        <button type="button" class="btn btn-block emergo-green-button" @click="updatePreferences">
          Save Changes
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Popover } from 'element-ui';
import Loader from '../UIComponents/Loader.vue';
import ProfileNotificationsGeneral from './ProfileNotificationsGeneral.vue';
import NotificationRegulatoryUpdate from './NotificationRegulatoryUpdate.vue';
import NotificationNoService from './NotificationNoService.vue';
import { getActiveServices } from '../../apis/marketPlace';
import { getAllCountries } from '../../apis/countriesList';
import NotificationSmartBuilder from './NotificationSmartBuilder.vue';
import ProfileNotificationSmartExchange from './ProfileNotificationSmartExchange.vue';
import EventBus from '../../utils/event-bus';
import permissionsList from '../UIComponents/mixins/rbacPermissionsMixin';
import { checkSmartExchangeProjects } from '../../apis/smartExchange';
import { getCookie } from '../../utils/common';

import {
  getUserEmailAlertsPreferences,
  updateUserEmailAlertsPreferences
} from '../../apis/profile';
// import BasePopover from '../Common/BasePopover.vue';

export default {
  mixins: [permissionsList],
  props: ['roleId', 'account_id', 'regWatchprefTab'],
  components: {
    ProfileNotificationsGeneral,
    ProfileNotificationSmartExchange,
    Loader,
    NotificationRegulatoryUpdate,
    NotificationNoService,
    NotificationSmartBuilder,
    // BasePopover,
    'el-popover': Popover
  },
  data() {
    return {
      account_type_id: '',
      regpathway_email_preference: true,
      regpathway_in_app_preference: true,
      prodclfn_email_preference: true,
      prodclfn_in_app_preference: true,
      displayRegPathwayNotifications: '',
      displayProdClsfnNotifications: '',
      permissions: [],
      sx_in_app_preference: true,
      sb_in_app_preference: true,
      sb_email_preference: true,
      display_smart_exchange: false,
      no_display_smart_builder: false,
      displaySmartBuilder: '',
      errors: [],
      loaderStatus: false,
      activeAlertPrefTab: 'RegTracker',
      addedServices: '',
      displayRegTracker: '',
      no_display_regtracker: false,
      displayRegUpdates: '',
      no_display_regwatch: false,
      frequency_options: [
        { label: 'Never', value: 'never' },
        { label: 'Weekly summary', value: 'weekly' },
        { label: 'Daily summary', value: 'daily' },
        { label: 'Every alert', value: 'immediate' }
      ],
      email_frequency: {
        email_registration_deleted: '',
        email_registration_expire_soon: '',
        email_registration_modified: '',
        email_registration_new: '',
        email_registration_status_change: '',
        email_regulatory_change: ''
      },
      regulatory_email_notification_country_ids: '',
      WeeklyNotificationDay: '',
      selectedPreferences: {
        alertRegistrationExpireSoon: '',
        alertRegistrationStatusChange: '',
        alertRegulatoryChange: '',
        alertRegistrationNew: '',
        alertRegistrationModified: '',
        alertRegistrationDeleted: '',
        alertRegulatoryAlertNew: '',
        alertRegulatoryAlertReview: ''
      },
      infoActive: false,
      sync_display: false,
      default_country: 0
    };
  },
  async created() {
    this.loaderStatus = true;
    await this.getAllPremiumServices();
    this.validateFeatures();
    this.displayRegTracker = this.validateService(1);
    this.no_display_regtracker = !this.displayRegTracker;
    this.displayRegUpdates = this.validateService(4);
    this.no_display_regwatch = !this.displayRegUpdates;
    this.displaySmartBuilder = this.validateService(3);
    this.no_display_smart_builder = !this.displaySmartBuilder;
    this.displayProdClsfnNotifications = this.validateService(6);
    this.displayRegPathwayNotifications = this.validateService(7);
    const token = getCookie('Authorization').split('Bearer ')[1];
    const showSEFlag = await checkSmartExchangeProjects(token);
    if (this.roleId !== 4 && this.roleId !== 6 && showSEFlag) {
      // smart exchange
      this.display_smart_exchange = true; // for tab and save changes option
    }
    await this.loadPreferences();
    if (this.regWatchprefTab !== '') {
      this.activeAlertPrefTab = this.regWatchprefTab;
    }
    this.account_type_id = JSON.parse(localStorage.getItem('userData')).account_type_id;
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    async validateFeatures() {
      this.loaderStatus = true;
      this.permissions = [];
      const servicesList = ['REGULATORY_WATCH'];
      const modulesList = ['REGULATORY_UPDATE_SETTINGS'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
      this.loaderStatus = false;
    },
    async updatePreferences() {
      this.loaderStatus = true;
      let regsIds = [];
      let emailFrequency = '';
      if (this.displayRegUpdates) {
        if (!this.regulatory_email_notification_country_ids.includes(this.default_country)) {
          regsIds = this.$refs.regUpdate.reg_notif_country_ids.filter(
            (id) => id !== this.default_country
          );
        } else {
          regsIds = this.$refs.regUpdate.reg_notif_country_ids;
        }
        emailFrequency = this.$refs.regUpdate.emailFrequency;
      } else {
        regsIds = this.regulatory_email_notification_country_ids;
        emailFrequency = this.email_frequency.email_regulatory_change;
      }
      const countryList = localStorage.getItem('countryList')
        ? JSON.parse(localStorage.getItem('countryList'))
        : await getAllCountries();

      const result = countryList
        .filter((value) => regsIds.includes(value.id))
        .map((country) => country.country_name);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Regulatory watch countries',
        countryList: result
      });
      const data = {
        alertRegistrationExpireSoon: this.selectedPreferences.alertRegistrationExpireSoon,
        alertRegistrationStatusChange: this.selectedPreferences.alertRegistrationStatusChange,
        alertRegistrationNew: this.selectedPreferences.alertRegistrationNew,
        alertRegistrationModified: this.selectedPreferences.alertRegistrationModified,
        alertRegistrationDeleted: this.selectedPreferences.alertRegistrationDeleted,
        alertRegulatoryAlertNew: this.selectedPreferences.alertRegulatoryAlertNew,
        alertRegulatoryAlertReview: this.selectedPreferences.alertRegulatoryAlertReview,
        email_registration_deleted: this.email_frequency.email_registration_deleted,
        email_registration_expire_soon: this.email_frequency.email_registration_expire_soon,
        email_registration_modified: this.email_frequency.email_registration_modified,
        email_registration_new: this.email_frequency.email_registration_new,
        email_registration_status_change: this.email_frequency.email_registration_status_change,
        email_regulatory_change: emailFrequency,
        regulatory_email_notification_country_ids: regsIds,
        email_weekly_notification_day: this.WeeklyNotificationDay,
        sync_display: this.sync_display,
        sb_email_preference: this.sb_email_preference,
        sb_in_app_preference: this.sb_in_app_preference,
        sx_in_app_preference: this.sx_in_app_preference,
        pc_email_preference: this.prodclfn_email_preference,
        pc_in_app_preference: this.prodclfn_in_app_preference,
        rp_email_preference: this.regpathway_email_preference,
        rp_in_app_preference: this.regpathway_in_app_preference
      };
      const response = await updateUserEmailAlertsPreferences(data);
      if (response.status) {
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Preferences updated successfully!',
          group: 'custom-notification'
        });
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Preferences update failed!',
          group: 'custom-notification'
        });
      }
      this.loaderStatus = false;
      EventBus.$emit('updateRegWatch');
    },
    async loadPreferences() {
      this.loaderStatus = true;
      const data = await getUserEmailAlertsPreferences();
      if (data.regulatory_email_notification_country_ids) {
        this.regulatory_email_notification_country_ids =
          data.regulatory_email_notification_country_ids;
      }
      this.WeeklyNotificationDay = data.email_weekly_notification_day;
      Object.keys(data).forEach((i) => {
        if (typeof this.email_frequency[i] !== 'undefined') {
          this.email_frequency[i] = data[i];
        }
        if (typeof this.selectedPreferences[i] !== 'undefined') {
          this.selectedPreferences[i] = data[i];
        }
      });
      this.sync_display = data.sync_display;
      this.default_country = data.default_country;
      this.sb_email_preference = data.sb_email_preference;
      this.sb_in_app_preference = data.sb_in_app_preference;
      this.sx_in_app_preference = data.sx_in_app_preference;
      this.prodclfn_email_preference = data.pc_email_preference;
      this.prodclfn_in_app_preference = data.pc_in_app_preference;
      this.regpathway_email_preference = data.rp_email_preference;
      this.regpathway_in_app_preference = data.rp_in_app_preference;
      this.loaderStatus = false;
    },
    validateService(serviceId) {
      return this.addedServices.some((value) => value === serviceId);
    },
    async getAllPremiumServices() {
      // To know active services for tab level
      const accoountServices = await getActiveServices(localStorage.getItem('accountId'));
      this.addedServices = accoountServices.services || [];
    },
    getLoaderStatus(status) {
      this.loaderStatus = status;
    }
  }
};
</script>
<style lang="scss" scoped>
$font-family-roboto: 'Roboto';
$font-style-normal: normal;
.indicator-block {
  margin: 20px 5px 0 0;
  border: 1px solid $gray74;
  border-radius: $radius10;
}
.indicator-message-expires {
  color: #0c3c61;
  font-size: $font-14;
  text-align: center;
  padding: 10px;
  font-style: normal;
  font-weight: $font-weight-normal;
  width: 90%;
  margin: auto;
}
.container1 {
  position: absolute;
  left: 0px;
  right: 0px;
  display: flex;
  flex-direction: column;
  max-height: calc(84vh - 271px);
  margin: 0px 20px;
  scrollbar-width: thin;
}
.section {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.scrollable-content {
  flex-grow: 1;
  overflow: auto;
  overflow-x: hidden;
  min-height: 0;
}
.info-img {
  width: 20px;
  vertical-align: top;
  margin-left: 4px;
  margin-top: 1px;
}
.alert_text {
  font-family: $font-family-roboto;
  font-style: $font-style-normal;
  font-weight: $font-weight-normal;
  font-size: $font-14;
  line-height: 16px;
  vertical-align: bottom;
  color: $dark-black-alpha !important;
  margin-bottom: 0px;
}
.header_label_text {
  font-weight: $font-weight-medium;
  font-size: $font-16;
  line-height: 19px;
  color: $dark-black-alpha;
}

input[type='checkbox'] {
  opacity: 0;
  position: absolute;
  z-index: 1;
  width: 18px !important;
  height: 18px !important;
  left: 0;
  top: 0;
  margin: 0 !important;
}
.radio label {
  cursor: none;
}
.error_message,
.matches {
  margin-top: 0px;
  margin-bottom: 5px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  background-color: $medium-white;
  padding: 8px;
  color: $light-danger;
  list-style-type: none;
  display: block;
  font-size: 0.8em;
  text-align: center;
}
.error_msgenter,
.pwd_mismatch {
  padding-left: 0px;
  padding-right: 0px;
}
.error_enter {
  display: none;
}
.notification_tabs {
  font-family: $font-family-roboto;
  font-style: $font-style-normal;
  font-weight: $font-weight-normal;
  padding: 0px 20px;
  .el-tabs__item {
    font-size: $font-16;
  }
  .el-tabs__header {
    margin-bottom: 15px;
  }
}
.alert-content {
  font-size: $font-14;
  line-height: 16px;
  font-weight: $font-weight-normal !important;
  color: $dark-black-alpha;
}
.row_wrapper {
  padding-top: 8px;
  padding-bottom: 8px;
  border-bottom: 0.5px solid $gray74;
  margin-right: -10px;
}
.row_wrapper {
  &.pb-15 {
    padding-bottom: 15px;
  }
}
.toggle_switch {
  margin-top: 5px;
}
.switch {
  margin-left: 0;
}

.display_xs {
  display: none;
}
.footer {
  padding-top: 10px;
  position: absolute;
  bottom: 0%;
  padding-bottom: 2%;
  right: 0;
  background-color: $white;
}
.xs-mr-tp-5 {
  position: relative;
  left: 16px;
  width: 23%;
}
::v-deep .main_popover {
  .popover {
    &.bottom {
      left: -230px !important;
      border: none;
      .arrow {
        opacity: 1;
        left: 313px !important;
      }
    }
  }
}
.btn {
  opacity: unset;
}
@media screen and (max-width: 767px) {
  .hide_xs {
    display: none;
  }
  .xs-mr-tp-5 {
    margin-top: 5px;
  }
  .display_xs {
    display: block !important;
  }
  .footer {
    padding-bottom: 5%;
  }
  .switch {
    margin-left: 0px !important;
  }
}

@media (min-width: 1024px) and (max-width: 1140px) {
  .in_app_label {
    padding: 0px;
  }
}
@media (min-width: 768px) and (max-width: 850px) {
  .in_app_label {
    padding: 0px;
  }

  .xs-mr-tp-5 {
    position: relative;
    left: 15px;
    width: 22%;
  }
}
@media (max-width: 576px) {
  .xs-pd-lt-0 {
    padding-left: 0px;
  }
  .xs-pd-rt-0 {
    padding-right: 0px;
  }
  .xs-mr-bt-10 {
    margin-bottom: 10px;
  }

  .xs-mr-tp-5 {
    position: relative;
    left: unset;
    width: 45%;
    ::v-deep {
      .multiselect.multiselect-single-dropdown {
        position: relative;
        left: 20px;
      }
    }
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .container1 {
    max-height: 22vh;
  }

  .toggle_switch {
    padding-left: 0;
  }
}
@media (width: 1024px) and (height: 768px) {
  .container1 {
    max-height: calc(84vh - 420px) !important;
  }
}
@media screen and (width: 768px) {
  .container1 {
    max-height: 37vh !important;
  }
  .toggle_switch {
    padding-left: 0;
  }
}
@media (min-width: 321px) and (max-width: 767px) {
  .container1 {
    max-height: 42vh;
  }
  .indicator-message-expires {
    width: 100%;
  }
}
@media screen and (max-width: 320px) {
  .container1 {
    max-height: 35vh;
  }
  .indicator-message-expires {
    width: 100%;
  }
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px) {
  .notification_tabs {
    max-height: 46vh;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
  }
  .container1 {
    max-height: 100%;
    position: relative;
  }

  .xs-mr-tp-5 {
    position: relative;
    left: unset;
    right: 6px;
    ::v-deep {
      .multiselect.multiselect-single-dropdown {
        margin-left: 20px;
      }
    }
  }
}
/* iphone5 landscape and below */
@media (max-width: 640px) and (max-height: 360px) {
  .notification_tabs {
    max-height: 42vh;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
  }
  .container1 {
    max-height: 42vh;
  }

  .xs-mr-tp-5 {
    position: relative;
    left: unset;
    width: 45%;
    ::v-deep {
      .multiselect.multiselect-single-dropdown {
        // margin-left: 20px;
      }
    }
  }
}
/* iphone 6 and 6+ landscape  */
@media (device-width: 736px) and (device-height: 414px),
  (device-width: 667px) and (device-height: 375px) {
  .notification_tabs {
    max-height: 42vh;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
  }
  .container1 {
    max-height: 100%;
    position: relative;
  }

  .xs-mr-tp-5 {
    position: relative;
    left: unset;
    width: 45%;
    ::v-deep {
      .multiselect.multiselect-single-dropdown {
        margin-left: 20px;
      }
    }
  }
}
</style>
